import { client } from "../../../infrastructure/graphql/client";
import {
  GET_LATEST_COST_ANALYSIS,
  ANALYZE_COSTS,
} from "../../../infrastructure/graphql/aiQueries/costAnalysisQueries";

export class CostAnalysisService {
  async getLatestCostAnalysis() {
    try {
      const result = await client.query({
        query: GET_LATEST_COST_ANALYSIS,
        fetchPolicy: "network-only",
      });

      const response = result.data?.getLatestCostAnalysis;

      if (!response) {
        return {
          success: false,
          message: "No response from server",
          data: null,
        };
      }

      return {
        success: true,
        data: response,
      };
    } catch (error) {
      console.error("Get latest cost analysis error:", error);
      const errorMessage = error.graphQLErrors?.[0]?.message || "Network error";
      return {
        success: false,
        message: errorMessage,
        data: null,
      };
    }
  }

  async analyzeCosts() {
    try {
      const result = await client.mutate({
        mutation: ANALYZE_COSTS,
      });

      const response = result.data?.analyzeCosts;

      if (!response) {
        return {
          success: false,
          message: "No response from server",
          data: null,
        };
      }

      return {
        success: true,
        data: response,
      };
    } catch (error) {
      console.error("Analyze costs error:", error);
      const errorMessage = error.graphQLErrors?.[0]?.message || "Network error";
      return {
        success: false,
        message: errorMessage,
        data: null,
      };
    }
  }
}